import { isPlatformBrowser } from '@angular/common';
import {
  AfterViewInit,
  Directive,
  ElementRef,
  inject,
  input,
  output,
  PLATFORM_ID,
} from '@angular/core';
import { environment } from '@environments/environment';
import { ENVIRONMENTS } from '@shared/constants';

@Directive({
  standalone: true,
  selector: '[b2cDeferLoad]',
})
export class DeferLoadDirective implements AfterViewInit {
  deferLoad = output<void>();

  threshold = input<number | number[]>(0.25);
  rootMargin = input<string>('0px 0px 15% 0px');

  private readonly platformId = inject(PLATFORM_ID);
  private intersectionObserver?: IntersectionObserver;
  private readonly element: ElementRef = inject(ElementRef);

  ngAfterViewInit(): void {
    // IntersectionObserver is not available during SSR
    if (!isPlatformBrowser(this.platformId)) {
      // Emit immediately on server to ensure content renders
      this.deferLoad.emit();
      return;
    }

    this.intersectionObserver = new IntersectionObserver(
      (entries: Array<IntersectionObserverEntry>) => {
        this.checkForIntersection(entries);
      },
      {
        root: null,
        threshold: this.threshold(),
        rootMargin: this.rootMargin(),
      }
    );
    this.intersectionObserver.observe(this.element.nativeElement as Element);
  }

  checkForIntersection(entries: Array<IntersectionObserverEntry>): void {
    entries.forEach((entry: IntersectionObserverEntry) => {
      if (
        [ENVIRONMENTS.CYPRESS, ENVIRONMENTS.PLAYWRIGHT].includes(
          environment.env
        ) ||
        (entry.isIntersecting && entry.target === this.element.nativeElement)
      ) {
        this.deferLoad.emit();
        this.intersectionObserver?.unobserve(
          this.element.nativeElement as Element
        );
        this.intersectionObserver?.disconnect();
      }
    });
  }
}
